import { useState } from "react";
import { Input } from "reactstrap";

import styles from "Pages/Admin/ClientHealth/ClientHealth.module.css";

export default function useDurationDropdown() {
    const durations = {
        24: "24",
        48: "48",
        week: "week",
        month: "month",
    };

    const [duration, setDuration] = useState(durations[24]);

    const changeDuration = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDuration(e.target.value);
    };

    const durationDropdown = (
        <Input
            type="select"
            className={styles.durationDropdown}
            onChange={changeDuration}
            value={duration}
        >
            <option value={durations[24]}>24 Hours</option>
            <option value={durations[48]}>48 Hours</option>
            <option value={durations.week}>Week</option>
            <option value={durations.month}>Month</option>
        </Input>
    );

    return { durationDropdown, duration };
}
